import {FAQ_ALL_CATEGORY} from '@/constants/help';
import {helpApiBase} from '..';
import {
  FaqBodyResponse,
  FaqListResponse,
  FaqMainCategoryIdResponse,
  SubCategoryResponse,
} from './type';

export const getFaqMainCategoryId = (
  subCategory: string,
): Promise<FaqMainCategoryIdResponse> => {
  return helpApiBase({
    command: 'CommonNode',
    domainId: 'sooplive',
    nodeId: subCategory,
  });
};

export const getFaqSubCategory = ({
  mainCategory,
}): Promise<SubCategoryResponse> => {
  return helpApiBase({
    command: 'CommonNodeList',
    domainId: 'sooplive',
    serviceType: 'SVFAQ',
    parentId: mainCategory,
  });
};

export const getFaqList = ({category, page}): Promise<FaqListResponse> => {
  return helpApiBase({
    command: 'FaqList',
    domainId: 'sooplive',
    nodeIds: category,
    pageNo: page,
  });
};

export const getFaqBody = ({questionId}): Promise<FaqBodyResponse> => {
  return helpApiBase({
    command: 'FaqDetailView',
    domainId: 'sooplive',
    nodeId: FAQ_ALL_CATEGORY,
    kbId: questionId,
  });
};
